import defaultHomeUrls from '../api/data-dummy/default-home-urls.json';
import { HOME_URL } from '../utils/Constants';

export const useHomeUrls = () => {
    const homeUrls = HOME_URL;
    return {
        ...defaultHomeUrls,
        ...homeUrls,
    };
};
